<template>
  <div class="sc-comparison-table-row">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ScComparisonTableRowComponent',
  created () {
    if (!this.$slots.default) {
      throw new Error('Default slot is mandatory in Sc Comparsion Table Row Component')
    }
  }
}
</script>
<style scoped>
</style>
